<template>
  <v-card class="mx-auto">
    <v-card-title class="primary--text">
      <span class="font-weight-light" :class="$style.cardTitle">
        Giá Nông Sản Trong Tuần
      </span>
      <v-spacer/>
      <v-chip 
        v-if="items[0] && items[0].ngay_cap_nhat"
        :ripple="false" class="mr-2"
        @click="goViewMarket()"
      >
        Tính đến ngày {{items.length ? items[0].ngay_cap_nhat : ''}}
      </v-chip>
      <v-chip
        outlined
        color="primary"
        dark
        to="/market-price"
      >
        <span class="caption">
          Xem tất cả
        </span>
      </v-chip>
    </v-card-title>
    <v-card-text :class="$style.marketTableBody">
      <v-data-table
        disable-sort
        :headers="headers"
        :items="items"
        :hide-default-footer="true"
        disable-pagination
        fixed-header
        :loading="loading"
        group-by="market_product.product_type.name"
        height="340"
      >
        <template v-slot:group.header="{items, isOpen, toggle}">
          <th colspan="5" class="text-subtitle-2">
            {{ items[0].market_product.product_type ? items[0].market_product.product_type.name : '' }}
          </th>
        </template>
        <template v-slot:header.market_product.name="{ header }">
          {{ header.text.toUpperCase() }}
        </template>
        <template v-slot:header.market_product.don_vi_tinh="{ header }">
          {{ header.text.toUpperCase() }}
        </template>
        <template v-slot:header.prev_l_price="{ header }">
          {{ header.text.toUpperCase() }}
        </template>
        <template v-slot:header.l_price="{ header }">
          {{ header.text.toUpperCase() }}
        </template>
        <template v-slot:header.h_price="{ header }">
          {{ header.text.toUpperCase() }}
        </template>
        <!-- <template v-slot:item.l_price="{ item }">
          {{ item.l_price | currency }}
          <span v-html="priceStatus(item.l_price, item.prev_l_price)"/>
            - {{ item.h_price | currency }}
          <span v-html="priceStatus(item.h_price, item.prev_h_price)"/>
        </template> -->
        <template v-slot:item.prev_l_price="{ item }">
          {{ item.prev_l_price | currency }} - {{ item.prev_h_price | currency }}
        </template>
        <template v-slot:item.l_price="{ item }">
          {{ item.l_price | currency }} - {{ item.h_price | currency }}
        </template>
        <template v-slot:item.h_price="{ item }">
          <!-- <span v-html="priceStatus(item.l_price, item.prev_l_price)"/> 
          - <span v-html="priceStatus(item.h_price, item.prev_h_price)"/> -->
          <span v-html="priceStatusNew(item)"></span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      items: [],
      headers: [
        { text: "Tên mặt hàng", value: "market_product.name"  },
        {
          text: "Đơn vị tính",
          value: "market_product.don_vi_tinh",
          align: "center"
        },
        { text: "Giá bán tuần trước", value: "prev_l_price", align: "center"  },
        { text: "Giá bán tuần này", value: "l_price", align: "center"  },
        { text: "So với tuần trước", value: "h_price", align: "center"  }
      ],
      date: null
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loading = true;
      axios
        .get("api/v1/public/get-price-current-week")
        .then((response) => {
          this.items = response.data;
          this.date = response.data[0].ngay_cap_nhat;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    priceStatus(now, prev) {
      let _now = now ? parseInt(now) : 0,
          _prev = prev ? parseInt(prev) : 0,
          _diff = 0;
      if(!_prev) return null;
      _diff = _now-_prev;
      let val = ((_diff/prev)*100).toFixed(2);
      if(val == 0) return `Ổn định`;
      if(val < 0) {
        return `<span class="red--text">Giảm ${this.$options.filters.currency(Math.abs(_diff),'đ')}</span>`;
      }
      return `<span class="green--text">Tăng ${this.$options.filters.currency(_diff,'đ')}</span>`;
    },
    priceStatusNew(item) {
      let _now_l = item.l_price ? parseInt(item.l_price) : 0,
          _prev_l = item.prev_l_price ? parseInt(item.prev_l_price) : 0,
          _now_h = item.h_price ? parseInt(item.h_price) : 0,
          _prev_h = item.prev_h_price ? parseInt(item.prev_h_price) : 0,
          _diff_l = 0,
          _diff_h = 0,
          lbl_l,
          lbl_h,
          cls_l,
          cls_h;

      // has not prev price
      if(!_prev_l || !_prev_h)
        return `-`;

      _diff_l = _now_l-_prev_l;
      _diff_h = _now_h-_prev_h;

      // none
      if(_diff_l == 0 && _diff_h == 0) {
        return `<span>Ổn định</span>`;
      } 
      
      // up and up
      if(_diff_l > 0 && _diff_h > 0) {
        return `<span class="green--text">Tăng ${this.reorder(_diff_l, _diff_h)}</span>`;
      }
      
      // down and down
      if(_diff_l < 0 && _diff_h < 0) {
        return `<span class="red--text">Giảm ${this.reorder(_diff_l, _diff_h)}</span>`;
      }

      // set label, class
      lbl_l = _diff_l < 0 ? 'Giảm' : 'Tăng';
      lbl_h = _diff_h < 0 ? 'Giảm' : 'Tăng';
      cls_l = _diff_l < 0 ? 'red--text' : 'green--text';
      cls_h = _diff_h < 0 ? 'red--text' : 'green--text';

      // none and up/down
      if(_diff_l == 0) {
        return `<span class="${cls_h}">${lbl_h} ${this.moneyFormat(_diff_h)}</span>`;
      }

      // up/down and none
      if(_diff_h == 0) {
        return `<span class="${cls_l}">${lbl_l} ${this.moneyFormat(_diff_l)}</span>`;
      }
 
      // up/down and up/down
      return `<span class="${cls_l}">${lbl_l} ${this.moneyFormat(_diff_l)}</span> - <span class="${cls_h}">${lbl_h} ${this.moneyFormat(_diff_h)}</span>`;
    },
    reorder(l_price, h_price){
      let min = l_price,
          max = h_price;
      if(Math.abs(min) > Math.abs(h_price)){
        min = h_price;
        max = l_price;
      }
      if(min == max) {
        return `${this.moneyFormat(min)}`;
      }
      return `${this.moneyFormat(min)} - ${this.moneyFormat(max)}`;
    },
    moneyFormat(number){
      if (!number) return 0;
      return this.$options.filters.currency(Math.abs(number),'đ');
    },
    goViewMarket(){
      this.$router.push({
        name: 'MarketView',
        params:{ date: this.date.replaceAll('/', '') }
      });
    }
  },
};
</script>
<style module>
  .marketTableBody{height: 350px;}
  .cardTitle{font-size: 16px;}
</style>